import { render, staticRenderFns } from "./BundleList.vue?vue&type=template&id=6fd178cf&scoped=true&"
import script from "./BundleList.vue?vue&type=script&lang=js&"
export * from "./BundleList.vue?vue&type=script&lang=js&"
import style0 from "./BundleList.vue?vue&type=style&index=0&id=6fd178cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd178cf",
  null
  
)

export default component.exports